import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { CloseCircleIcon, CloseMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { textColorL2 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getContactDisplayName, getPreferredContactName } from 'shared/utils/get_contact_display_name';
import { getInitials } from 'shared/utils/get_initials';
const containerIsInvalidCss = "cy96qr3";
const containerIsEditModeCss = "clo0zru";
const containerIsSingleCss = "c8cib30";
const containerCss = "cxsux9z";
const Container = forwardRef((props, ref) => {
  const {
    isInvalid,
    isEditMode,
    isSingle,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsInvalidCss]: isInvalid,
    [containerIsEditModeCss]: isEditMode,
    [containerIsSingleCss]: isSingle
  }, props.className)} />;
});
const contactContainerCss = "c1nkbl9g";
const ContactContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contactContainerCss, props.className)} />;
});
const deleteTagButtonCss = "d1i0br8h";
const DeleteTagButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(deleteTagButtonCss, props.className)} />);
const ContactItem = ({
  contact
}) => {
  const preferredName = getPreferredContactName(contact);
  const displayName = getContactDisplayName(contact);
  return <ContactContainer>
      {preferredName && <FullStoryExclude>
          <Avatar src={contact.previewUrl} letter={getInitials(preferredName)} size="x-small" />
        </FullStoryExclude>}
      <div>
        <BodyText><FullStoryMask>{displayName}</FullStoryMask></BodyText>
      </div>
    </ContactContainer>;
};
export const ContactTag = ({
  item,
  onDelete,
  isSingle,
  isDisabled,
  isInvalid = false
}) => {
  const displayName = getContactDisplayName(item);
  return <Container isInvalid={isInvalid} isSingle={isSingle}>
      <ContactItem contact={item} />
      {(!isSingle || !isDisabled) && <div>
          <DeleteTagButton aria-label={`${I18n.t('action.remove')} ${displayName}`} onClick={onDelete} data-component="contact-item">
            {isSingle ? <CloseCircleIcon color={textColorL2} /> : <CloseMiniIcon />}
          </DeleteTagButton>
        </div>}
    </Container>;
};

require("./contact_tag.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_tag.js");